import React from 'react'
import { useHistory } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ChatActive from '../images/burger-menu/chat-assistant-white.svg'
import Chat from '../images/burger-menu/chat-assistant-red.svg'
import AITranslatorActive from '../images/burger-menu/ai-translator-white.svg'
import AITranslator from '../images/burger-menu/ai-translator-red.svg'
import HomeActive from '../images/burger-menu/home-white.svg'
import Home from '../images/burger-menu/home-red.svg'
import AIImagesActive from '../images/burger-menu/ai-images-white.svg'
import AIIMages from '../images/burger-menu/ai-images-red.svg'
import SpeechToSpeechActive from '../images/burger-menu/speech-to-speech-white.svg'
import SpeechToSpeech from '../images/burger-menu/speech-to-speech-red.svg'
import VideoMakerActive from '../images/burger-menu/video-maker-white.svg'
import LiveChatActive from '../images/burger-menu/live-chat-white.svg'
import LiveChat from '../images/burger-menu/live-chat-red.svg'
import VideoMaker from '../images/burger-menu/video-maker-red.svg'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { customTheme } from '../styling'

export const mainListItems = () => {
  const history = useHistory()
  
  return (<div style={{margin:'0 0.5rem', marginTop:'1rem'}}>
    <ListItem button style={{ backgroundColor:['/home'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/home')}>
      <ListItemIcon>
      <img src={['/home'].includes(location.pathname) ? HomeActive : Home}/>
      </ListItemIcon>
      <ListItemText style={['/home'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Home" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/chat'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/chat')}>
      <ListItemIcon>
      <img src={['/chat'].includes(location.pathname) ? ChatActive : Chat}/>
      </ListItemIcon>
      <ListItemText style={['/chat'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Chat Assistant" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/translator'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/translator')}>
      <ListItemIcon>
      <img src={['/translator'].includes(location.pathname) ? AITranslatorActive : AITranslator}/>
      </ListItemIcon>
      <ListItemText style={['/translator'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="AI Translator" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/audio'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/audio')}>
      <ListItemIcon>
      <img src={['/audio'].includes(location.pathname) ? SpeechToSpeechActive : SpeechToSpeech}/>
      </ListItemIcon>
      <ListItemText style={['/audio'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Audio" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/images'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/images')}>
      <ListItemIcon>
      <img src={['/images'].includes(location.pathname) ? AIImagesActive : AIIMages}/>
      </ListItemIcon>
      <ListItemText style={['/images'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="AI Images" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/video-maker'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/video-maker')}>
      <ListItemIcon>
      <img src={['/video-maker'].includes(location.pathname) ? VideoMakerActive : VideoMaker}/>
      </ListItemIcon>
      <ListItemText style={['/video-maker'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Video maker" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/live-translator'].includes(location.pathname) && customTheme.colors.ui.red, borderRadius: 15}} onClick={() => history.push('/live-translator')}>
      <ListItemIcon>
      <img src={['/live-translator'].includes(location.pathname) ? LiveChatActive : LiveChat}/>
      </ListItemIcon>
      <ListItemText style={['/live-translator'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Live Translator" />
    </ListItem>
  </div>
  )
}

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>
  </div>
)